import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { User } from './auth';

interface AdminState {
  token: string | null;
  user: User | null;
  setToken: (token: string) => void;
  setUser: (user: User) => void;
  clearAuth: () => void;
  storageType: 'local' | 'session';
  refreshToken: string | null;
  setRefreshToken: (refreshToken: string) => void;

  isHydrated: boolean; // <-- NEW
  setIsHydrated: (isHydrated: boolean) => void; // <-- NEW
}

export const useAdminStore = create<AdminState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      refreshToken: null,
      storageType: 'local',
      setToken: (token: string) => set({ token }),
      setRefreshToken: (refreshToken: string) => set({ refreshToken }),
      setUser: (user: User) => set({ user }),
      clearAuth: () => {
        set({ token: null, user: null, refreshToken: null });
        localStorage.setItem('ihs-storage-type', JSON.stringify('local'));
        set({ storageType: 'local' });
      },
      isHydrated: false, // <-- NEW
      setIsHydrated: (isHydrated: boolean) => set({ isHydrated }), // <-- NEW
    }),
    {
      name: 'ihs-admin-storage',
      storage: createJSONStorage(() => sessionStorage),
      onRehydrateStorage: () => (state) => {
        state?.setIsHydrated(true); // <-- Trigger when hydration completes
      },
    }
  )
);
